// @core/api/endpoints/attachment/get_processing_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetProcessingStatusResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get attachment processing status
 * Returns the current processing status for an attachment including overall progress and status of individual tasks like thumbnail generation and transcoding.
 */
export async function GetProcessingStatus(
  attachment_id: string,
  options?: RequestOptions
): Promise<GetProcessingStatusResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id/processing-status`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.get<GetProcessingStatusResponse>(requestPath, { ...requestOptions });
}
